module.exports = __webpack_public_path__ + "static/yt-073e8b3aa8089030a95c0ea71627415c.jpg";